import React from 'react';

/**
 * Full-tab loading skeleton for LiveProgressModal tabs.
 * Shows a pulsing placeholder while data is loading.
 */
export function TabLoader({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 animate-in fade-in duration-200" data-testid="tab-loader">
      <div className="relative mb-4">
        <div className="w-10 h-10 rounded-full border-[3px] border-slate-200" />
        <div className="absolute inset-0 w-10 h-10 rounded-full border-[3px] border-transparent border-t-blue-500 animate-spin" />
      </div>
      <p className="text-sm text-slate-500 font-medium">{message}</p>
      {/* Skeleton lines */}
      <div className="w-full max-w-md mt-8 space-y-3 px-4">
        <div className="h-3 bg-slate-100 rounded-full animate-pulse w-full" />
        <div className="h-3 bg-slate-100 rounded-full animate-pulse w-4/5" />
        <div className="h-3 bg-slate-100 rounded-full animate-pulse w-3/5" />
        <div className="flex gap-3 mt-4">
          <div className="h-20 bg-slate-50 rounded-lg animate-pulse flex-1 border border-slate-100" />
          <div className="h-20 bg-slate-50 rounded-lg animate-pulse flex-1 border border-slate-100" />
          <div className="h-20 bg-slate-50 rounded-lg animate-pulse flex-1 border border-slate-100" />
        </div>
      </div>
    </div>
  );
}
